import { SidebarMenuGuestController } from './sidebar-menu-guest.controller'

/* @ngInject */
function sidebarMenuGuest () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/sidebar-menu-guest/sidebar-menu-guest-directive.html?$$REVISION$$',
    controller: SidebarMenuGuestController
  }
}

export { sidebarMenuGuest }
